export type ModelMetrics={steps?:{delay_ms?:number|null}[];diagnostic?:{duration_ms?:number;wait_ms?:number};fallback_reason?:string;cost_kind?:string;cost_usd?:number|null;reservation_usd?:number|null}
export function modelTiming(m:ModelMetrics){
 const delays=(m.steps??[]).map(s=>s.delay_ms).filter((v):v is number=>typeof v==='number'&&Number.isFinite(v)&&v>=0)
 return {queue_ms:delays.length?delays.reduce((a,b)=>a+b,0):null,duration_ms:m.diagnostic?.duration_ms??m.diagnostic?.wait_ms??null}
}
export function modelCostLabel(kind?:string|null,cost?:number|null){return kind==='unknown'?'שמירה לתקרה (לא ידוע)':cost==null?'החיוב טרם התקבל':kind==='actual'?'חיוב בפועל':'אומדן'}
export function modelCosts(m:ModelMetrics){
 // Before the metrics migration, cost_usd itself held the unknown reservation.
 const legacy=m.cost_kind==='unknown'&&m.reservation_usd==null
 return {known_usd:legacy?null:m.cost_usd??null,reservation_usd:m.reservation_usd??(legacy?m.cost_usd??.0684:0)}
}
